import { useLayout } from "../../context/LayoutContext.jsx";
import { useAuth } from "../../context/AuthContext.jsx";
import OverlayLayer from "../ui/OverlayLayer.jsx";
import { AsideMenuItem } from "./AsideMenuItem.jsx";
import menuItems from "../../menuAside.js";
import { mdiRobot } from "@mdi/js";
import BaseIcon from "../ui/BaseIcon.jsx";

export default function AsideMenu() {
  // Navigation moved to top NavBar — aside no longer rendered
  return null;
}
